import React, { useState, useEffect } from 'react';
import { Checkbox, Input, Tooltip, Upload } from 'antd';
import { CloseOutlined, PictureOutlined } from '@ant-design/icons';


const Checkboxes = ({ options = [], editable = true, onChange, disabled = false,  value = [],  }) => {

  const [localOptions, setLocalOptions] = useState(options);

  useEffect(() => {
    setLocalOptions(options);
  }, [options]);

  const handleOptionChange = (value, index) => {
    const updated = [...localOptions];
    updated[index] = value;
    setLocalOptions(updated);
    onChange?.(updated);
  };
  

  const handleAddOption = () => {
    const updated = [...localOptions, `Option ${localOptions.length + 1}`];
    setLocalOptions(updated);
    onChange?.(updated);
  };

    const handleRemoveOption = (index) => {
    if (index === 0) return;
    const updated = localOptions.filter((_, i) => i !== index);
    setLocalOptions(updated);
    onChange?.(updated);
  };
    

 

  return (
    <div style={{ width: '100%' }}>
      {localOptions.length > 0 ? (
        localOptions.map((option, index) => (
          <div key={index} style={{ display: 'flex', width: '100%', marginBottom:"4%" }} >

            <Checkbox disabled={disabled} checked={value?.includes(option)} onChange={(e) => onChange?.(e, option)} style={{marginRight:"2%"}} />

            {editable ? (
              <Input
                variant="underlined"
                value={option}
                onChange={(e) => handleOptionChange(e.target.value, index)}
                style={{ width: '90%',  }}
              />
            ) : (
              <span>{option}</span>
            )}
             {editable && (
                <div style={{marginRight:"2%"}}><Upload ><Tooltip title="Ajouter une image" ><PictureOutlined style={{ fontSize:20 }} /></Tooltip></Upload></div>
            )}
            {editable && index !== 0 && (
                <Tooltip title="Supprimer"> <CloseOutlined style={{fontSize:20}} onClick={() => handleRemoveOption(index)} /></Tooltip>
            )}
          </div>
        ))
      ) : (
        <span style={{ color: '#999', fontStyle: 'italic' }}>Aucune option définie <br/><br/></span>
      )}
      {editable && (
        <Checkbox value={null} checked={false}  onClick={handleAddOption}>
          Ajouter une option
        </Checkbox>
      )}
    </div>
  );
};

export default Checkboxes;
